import request from '@/plugins/admin_axios'

export const GetOwnerContextApi = async () => {
  const response = await request.get('owner/context/')
  return response.data
}

export const ListMyChildrenApi = async () => {
  const response = await request.get('owner/children/list/')
  return response.data
}

const buildOwnerFormData = (data) => {
  const formData = new FormData()
  formData.append('name', data.name)
  formData.append('cnpj', data.cnpj)
  formData.append('razao_social', data.razao_social)
  formData.append('urls', data.urls)
  formData.append('user_email', data.user_email)
  formData.append('user_password', data.user_password)
  formData.append('logo', data.logo)
  formData.append('background_color', data.background_color)
  formData.append('primary_color', data.primary_color)
  return formData
}

export const CreateMotherOwnerApi = async (data) => {
  const response = await request.post('owner/register/mother/', buildOwnerFormData(data))
  return response.data
}

export const CreateChildOwnerApi = async (data) => {
  const response = await request.post('owner/register/child/', buildOwnerFormData(data))
  return response.data
}
